import React from 'react';
import { Avatar, Flex } from 'antd';
import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';

import { RosterClient, SlackUser } from 'jf/api';
import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExDrawer } from 'jf/components/DevExDrawer';
import { useClientQuery } from 'jf/utils/useClientQuery';

type RespondentDetailsDrawerProps = {
  onClose: () => void;
  open: boolean;
  target?: SlackUser | null;
};

export const RespondentDetailsDrawers: React.FC<RespondentDetailsDrawerProps> = (props) => {
  const theme = useDevExTheme();
  const { studyRef } = useParams<{ studyRef: string }>();
  const infoBlock = (title, information) => {
    return (
      <Flex vertical gap={theme.variable.spacing.sm}>
        <div style={{ color: theme.color.text.secondary }}> {title} </div>
        <div> {information} </div>
      </Flex>
    );
  };

  const { data: rosterUsers } = useClientQuery(RosterClient.getStudyTargets, {
    studyRef,
    slackSelected: true,
  });
  const rosterUser = rosterUsers?.find((user) => user.email === props.target?.email);

  return props.target ? (
    <DevExDrawer
      title={props.target.realName ? props.target.realName : props.target.userName}
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      closable
    >
      <Flex vertical gap={theme.variable.spacing.md}>
        <strong style={{ fontSize: theme.variable.fontSize.md }}> Slack Profile </strong>
        <Flex gap={theme.variable.spacing.md}>
          <Avatar
            shape={'square'}
            style={{ backgroundColor: theme.color.background.active }}
            size="large"
            src={rosterUser?.slack?.profileImageUrl ?? <FontAwesomeIcon icon={faUsers} />}
          />
          <Flex vertical gap={theme.variable.spacing.md}>
            {infoBlock('Email', props.target.email)}
            {!!props.target.realName && infoBlock('Name', props.target.realName)}
            {infoBlock('Slack Username', `@` + props.target.userName)}
          </Flex>
        </Flex>
        {rosterUser && (
          <>
            <strong
              style={{
                fontSize: theme.variable.fontSize.md,
                paddingTop: theme.variable.spacing.sm,
              }}
            >
              Jellyfish Profile
            </strong>
            <Flex gap={theme.variable.spacing.md}>
              <Avatar
                shape={'square'}
                style={{ backgroundColor: theme.color.background.active }}
                size="large"
                src={<FontAwesomeIcon icon={faUsers} />}
              />
              <Flex vertical gap={theme.variable.spacing.md}>
                {infoBlock('Email', rosterUser.email)}
                {infoBlock('Name', rosterUser.name)}
                {Object.entries(rosterUser.segmentValueAssignment).map(([key, value]) =>
                  infoBlock(key, value)
                )}
              </Flex>
            </Flex>
          </>
        )}
      </Flex>
    </DevExDrawer>
  ) : null;
};
